
import { extendTheme } from "@chakra-ui/react";
import { globalStylesGray } from "./globalStylesGray";
import { breakpoints } from "./foundations/breakpoints";
import { buttonStylesGray } from "./components/buttonStylesGray";
import { badgeStyles } from "./components/badge";
import { linkStyles } from "./components/link";
import { inputStylesGray } from "./components/inputStylesGray";
import { CardComponent } from "./additions/card/CardStylesGray";
import { MainPanelComponent } from "./additions/layout/MainPanel";
import { PanelContentComponent } from "./additions/layout/PanelContent";
import { PanelContainerComponent } from "./additions/layout/PanelContainer";

// import { mode } from "@chakra-ui/theme-tools";
export default extendTheme(
  { breakpoints }, // Breakpoints
  globalStylesGray,
  buttonStylesGray, // Button styles
  badgeStyles, // Badge styles
  linkStyles, // Link styles
  inputStylesGray, // Input styles
  CardComponent, // Card component
  MainPanelComponent, // Main Panel component
  PanelContentComponent, // Panel Content component
  PanelContainerComponent // Panel Container component
);
